import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import { PageLoadingIndicator } from './common/components/design/spinner';
import { AppRoutes } from '@common/constants/routes';

const Admin = lazy(() => import('./admin'));
const Webstore = lazy(() => import('./webstore'));

const App = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoadingIndicator />}>
        <Routes>
          <Route path={AppRoutes.Admin + '/*'} element={<Admin />} />
          <Route path={AppRoutes.Webstore + '/*'} element={<Webstore />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
